import { getBaseApi } from "../api";

const authApi = getBaseApi();

export const login = async (data: { email: string; password: string }) => {
  return authApi.post("/auth/login", data);
};

export const register = async (data: { email: string; password: string; inviteToken: string }) => {
  return authApi.post("/auth/register", data);
};

export const forgotPassword = async (data: { email: string }) => {
  return authApi.post("/auth/forgot-password", data);
};

export const resetPassword = async (data: { email: string; newPassword: string; token: string }) => {
  return authApi.post("/auth/reset-password", data);
};